import { CDN_URL } from '@utils/constants/url.constants';
import Container from '@components/Container';
import React from 'react';
import { QRCode } from 'react-qrcode-logo';
import { detectDeviceParentDownload } from '@utils/helpers/detectdevice';

type InnerOuterRadii = {
  outer: [number, number, number, number];
  inner: [number, number, number, number];
};
type cornerRadii = [InnerOuterRadii, InnerOuterRadii, InnerOuterRadii];

const breakpoint = require('geniebook-ui/dist/themes/breakpoint');
const ParentQrCode = React.memo(() => {
  const googleLink: string =
    'https://play.google.com/store/apps/details?id=com.geniebook.parent';
  const iosLink: string =
    'https://apps.apple.com/sg/app/geniebook-parent/id1301096464';
  const qrEyeRadius: cornerRadii = [
    { outer: [3, 3, 3, 3], inner: [3, 3, 3, 3] },
    { outer: [3, 3, 3, 3], inner: [3, 3, 3, 3] },
    { outer: [3, 3, 3, 3], inner: [3, 3, 3, 3] },
  ];

  const [deviceLink, setDeviceLink] = React.useState<string>(
    'https://play.google.com/store/apps/details?id=com.geniebook.parent',
  );
  React.useEffect(() => {
    const device = detectDeviceParentDownload();
    if (device === 'ios') {
      setDeviceLink(iosLink);
    } else {
      setDeviceLink(googleLink);
    }
  }, []);

  const [width, setWidth] = React.useState<number>(window.innerWidth);
  function updateWidth() {
    setWidth(window.innerWidth);
  }

  React.useEffect(() => {
    window.addEventListener('resize', updateWidth);
    updateWidth();
    return () => {
      window.removeEventListener('resize', updateWidth);
    };
  }, []);

  return (
    <>
      <img
        className="lg:fixed lg:left-[38px] w-[315px] h-[350px] max-lg:ml-[106px] max-sm:ml-[50px] max-sm:w-[150px] max-sm:h-[183px] max-lg:h-[242px] max-lg:w-[200px] max-lg:flex-row"
        src={`${CDN_URL}assets/images/parent/Character_Father.svg`}
        alt=""
      />
      <img
        className="max-lg:hidden fixed w-[355px] h-[388px] bottom-[-34px] right-[38px]"
        src={`${CDN_URL}assets/images/parent/Character_mother_1a.svg`}
        alt=""
      />
      <Container className="parent_content_container my-auto">
        <div className="flex-auto h-[20px]"></div>
        <div className="lg:flex w-full max-h-[calc(100%-50px)]">
          <div className="mx-auto max-sm:max-w-[344px] max-lg:max-w-[619px] lg:min-w-[536px] relative flex flex-row">
            <div className="content_container relative">
              <img
                className="absolute mx-auto max-lg:mt-[32px] mt-[40px] w-[95%] h-[95%]"
                src={`${CDN_URL}assets/images/parent/Decoration.svg`}
                alt=""
              />
              <div className="flex flex-col justify-center mx-auto items-center bg-[#3F3A94] max-sm:w-[210px] max-sm:h-[44px] max-lg:w-[377px] max-lg:h-[80px] lg:w-[400px] lg:h-[88px] max-lg:mt-[32px] mt-[40px] max-sm:rounded-[29px] rounded-[18px] max-sm:shadow-[0px_9px_0px_0px_#282661] shadow-[0px_8px_0px_0px_#282661]">
                <div className="max-sm:text-[24px] text-[48px] font-bold text-center text-white">
                  We've Moved!
                </div>
              </div>
              <div className="text-[#262262] mx-auto max-sm:my-[16px] max-lg:my-[24px] my-[31px] flex flex-col max-sm:w-[296px] max-sm:h-[84px] max-lg:w-[539px] max-lg:h-[78px] w-[456px] h-[78px] text-center font-bold max-sm:text-[16px] max-sm:leading-[21px] text-[20px] leading-[26px]">
                Monitor your child's progress and activity easily on the
                Geniebook Parent mobile app. Scan or tap on the QR code to
                download.
              </div>
              <a href={deviceLink} target="_blank" rel="noreferrer">
                <div className="flex relative flex-col justify-center mx-auto items-center bg-[#6EBFE6] max-sm:w-[134px] max-sm:h-[133px] max-lg:w-[236px] max-lg:h-[232px] w-[276px] h-[274px] rounded-[12px] shadow-[0px_12px_0px_0px_#2CA2DB]">
                  <img
                    className="absolute w-[52px] h-[45px] -bottom-[12px] -right-[50px]"
                    src={`${CDN_URL}assets/images/parent/cursor.svg`}
                    alt=""
                  />
                  {width >= breakpoint.lg ? (
                    <QRCode
                      ecLevel={'L'}
                      eyeRadius={qrEyeRadius}
                      size={210}
                      value={deviceLink}
                      fgColor={'#1C1A3F'}
                      bgColor={'#6EBFE6'}
                    />
                  ) : width >= breakpoint.sm ? (
                    <QRCode
                      ecLevel={'L'}
                      eyeRadius={qrEyeRadius}
                      size={180}
                      value={deviceLink}
                      fgColor={'#1C1A3F'}
                      bgColor={'#6EBFE6'}
                    />
                  ) : (
                    <QRCode
                      ecLevel={'L'}
                      eyeRadius={qrEyeRadius}
                      size={100}
                      value={deviceLink}
                      fgColor={'#1C1A3F'}
                      bgColor={'#6EBFE6'}
                    />
                  )}
                </div>
              </a>
            </div>
          </div>
        </div>
        <div className="flex-auto h-[35px]"></div>
      </Container>
      <img
        className="max-lg:flex lg:hidden flex-col max-sm:w-[224px] max-sm:h-[170px] w-[326px] h-[246px] ml-auto mt-auto"
        src={`${CDN_URL}assets/images/parent/Character_mother_1b.svg`}
        alt=""
      />
    </>
  );
});

export default ParentQrCode;
